<mat-tab-group color="primary" selectedIndex="{{selectedIndex}}" (selectedIndexChange)="updateSelectedIndex($event)"
  data-cy="tab-settings">

  <mat-tab label="My Profile">
    <div class="account-settings">
      <div class="left-panel">
        <div class="title">Personal Details</div>

        <div class="input-group">
          <div class="form-grid">
            <mat-form-field color="primary" appearance="outline" class="first-name-field">
              <mat-label>First Name</mat-label>
              <input style="margin-top: 0px" matInput [formControl]="firstname" required>
              <mat-error *ngIf="firstname.invalid">{{getFirstNameErrorMessage()}}</mat-error>
            </mat-form-field>

            <mat-form-field color="primary" appearance="outline" class="last-name-field">
              <mat-label>Last Name</mat-label>
              <input style="margin-top: 0px" matInput [formControl]="lastname" required>
              <mat-error *ngIf="lastname.invalid">{{getLastNameErrorMessage()}}</mat-error>
            </mat-form-field>

            <div class="empty-column"></div>

            <mat-form-field color="primary" appearance="outline" class="email-field">
              <mat-label>Email address</mat-label>
              <input style="margin-top: 0px" matInput [formControl]="email" readonly>
              <mat-icon matSuffix class="verified-icon" *ngIf="email.value" matTooltip="Verified" matTooltipPosition="above">check_circle</mat-icon>
            </mat-form-field>

            <div class="mobile-field-group">
              <mat-form-field color="primary" appearance="outline" class="country-code-field">
                <mat-select [formControl]="countryCode">
                  <mat-option *ngFor="let country of allCountryCodes" value="{{country.code}}">
                    <span class="country-option">
                      <span class="flag-placeholder">{{country.flag}}</span>
                      {{country.code}}
                    </span>
                  </mat-option>
                  
                </mat-select>
              </mat-form-field>

              <mat-form-field color="primary" appearance="outline" class="mobile-number-field">
                <mat-label>Mobile number</mat-label>
                <input style="margin-top: 0px" matInput [formControl]="mobileNumber">
                <mat-icon matSuffix class="verified-icon" *ngIf="user.mobileVerified === 1" matTooltip="Verified" matTooltipPosition="above">check_circle</mat-icon>
              </mat-form-field>
            </div>

            <div class="verify-container" *ngIf="!isLocked">
              <button mat-stroked-button class="verify-btn" color="primary" (click)="verifyMobile()" 
                *ngIf="(!user.mobileVerified || user.mobile !== countryCode.value + '-' + mobileNumber.value)"
                [disabled]="verifyButtonDisabled">
                Verify
              </button>
              <div class="verify-timer" *ngIf="verifyButtonTimer > 0">
                <ng-container *ngIf="verifyButtonTimer > 60; else secondsTpl">
                  You can verify again in {{ verifyTimerMinutesValue }} minute{{ verifyTimerMinutesValue === 1 ? '' : 's' }}
                </ng-container>
                <ng-template #secondsTpl>
                  You can verify again in {{verifyButtonTimer}} second{{verifyButtonTimer === 1 ? '' : 's'}}
                </ng-template>
              </div>
            </div>
          </div>
        </div> 

              <div class="assigned-role">
                <div class="title" style="width: 100%;">
                  Two-factor authentication preference
                </div>
                <div class="fa-auth-preference">
                  <mat-radio-group aria-label="Select an option" color="primary" [formControl]="authPreference">
                    <mat-radio-button value="email">Email Address</mat-radio-button>
                    <mat-radio-button value="mobile" style="margin-left: 48px;" [disabled]="!user.mobileVerified">Mobile
                      Number</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

        <div class="assigned-role">
          <div class="title">
            Assigned Role
          </div>
          <div class="roles-list">
            <div class="role-item" *ngIf="userService.isAdmin">
              <div class="icon">
                <div class="rb rb-icon-admin"></div>
              </div>
              <div class="description">
                Admin
                <div class="secondary-title">
                  Can set other admins & create client level roles
                </div>
              </div>
            </div>
            <div class="role-item" *ngIf="userService.isAM || userService.isTrader">
              <div class="icon">
                <div class="rb rb-icon-person"></div>
              </div>
              <div class="description">
                Standard
                <div class="secondary-title">
                  Can access entire account
                </div>
              </div>
            </div>
            <div class="role-item" *ngIf="userService.isExternal">
              <div class="icon">
                <div class="rb rb-icon-external-user"></div>
              </div>
              <div class="description">
                External
                <div class="secondary-title">
                  Limited advertiser access
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reset-password">
          <div class="title">Security & Password</div>
          <div class="action"><a href="javascript:void(0);" (click)="openDialog()">Reset Password</a></div>
        </div>

        <div class="save-btn">
          <button mat-raised-button class="rubii-btn" color="primary" (click)="saveAccount()"><span
              style="margin: 0 1rem">Save</span></button>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Custom Fields" *ngIf="tabs.includes('custom-fields')">
    <app-custom-field></app-custom-field>
  </mat-tab>

  <mat-tab label="Users" *ngIf="userService.isAdmin">
    <div class="tenant-settings">
      <div class="user-roles">
        <div class="title">Users & Roles</div>
        <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
          <app-roles></app-roles>
          <div class="new-user" (click)="addNewUser()" data-cy="add-new-user-btn">
            <div class="icon">
              <div class="plus"><mat-icon>add</mat-icon></div>
            </div>
            <div class="second">Add New User</div>
          </div>
        </div>
      </div>
      <app-search-inline [placeholderStr]="'Search User'" (keywordChange)="searchUser($event)"
        data-cy="search-user-inline-wrapper"></app-search-inline>
      <div class="role-list">
        <form [formGroup]="newUserFormGroup">
          <table>
            <thead>
              <tr>
                <th class="name-col"> Name</th>
                <th class="email-col"> Email</th>
                <th class="role-col"> Roles</th>
                <th class="margin-col">Margin Enabled?</th>
                <th class="last-logged-in-col">Last logged in</th>
                <th class="account-status" *ngIf="twoFaFeatureOn">Account Status</th>
                <th class="action-col"> Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="!users || !users.length" style="text-align: center">
                <td colspan="5">
                  Empty User
                </td>
              </tr>
              <tr *ngFor="let user of users">
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td style="display: flex;align-items: center;">
                  <app-role-selector [width]="200" [selectedRoleIds]="user.roles"
                    (roleSelected)="handleInlineRoleChange($event,user)"
                    data-cy="role-selector-inline-wrapper"></app-role-selector>
                </td>
                <td>{{user.canSeeMargin ? 'Yes' : 'No' }}</td>
                <td class="last-logged-in-col">
                  {{user.lastLogin}}
                </td>
                <td *ngIf="twoFaFeatureOn" class="account-status">
                  <div (click)="unlockedUser(user)" *ngIf="user.isLocked" style="cursor: pointer;display: flex;flex-direction: row;">
                    <img matTooltip="Click to unlock" [matTooltipPosition]="'above'" style="display: inline-block;margin-right: 4px;" src="assets/images/lock-outline.svg"
                      alt="Locked">
                    <div *ngIf="user.isLocked" matTooltip="Click to unlock" [matTooltipPosition]="'above'"  style="cursor: pointer;">Locked</div>
                  </div>
                  <div *ngIf="!user.isLocked" style="display: flex;flex-direction: row;">
                    <img style="display: inline-block;margin-right: 4px;" src="assets/images/lock-open-variant-outline.svg"
                      alt="'Unlocked'">
                    <div>Unlocked</div>
                  </div>
                </td>
                <td class="action-col">
                  <div class="user-list-action" matTooltip="Edit" (click)="editUser(user);" data-cy="edit-user-btn">
                    <img src="assets/images/edit.svg" alt="edit-user">
                  </div>
                  <div class="user-list-action" matTooltip="Reset Password" (click)="resetPassword(user.email);"
                    data-cy="reset-user-pwd-btn">
                    <img src="assets/images/lock-reset.svg" alt="reset-password">
                  </div>
                  <div class="user-list-action" matTooltip="Delete User" data-cy="delete-user-btn"
                    (click)="updateUserStatus(user.id, user.email, shared.dicts.UserStatus.ACTIVE);">
                    <img src="assets/images/delete.svg" alt="delete-user">
                  </div>
                  <div class="user-list-action" style="margin-top: 4px;" matTooltip="Resend Invite"
                    data-cy="resend-invite-user-btn" *ngIf="user.status === shared.dicts.UserStatus.WAIT_FOR_CONFIRM"
                    (click)="updateUserStatus(user.id, user.email, user.status);">
                    <img src="assets/images/vector.svg" alt="resend-invite">
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <mat-paginator color="primary" (page)="pageChanged($event)" [length]="page.total"
                    [pageSize]="page.pageSize" showFirstLastButtons="true" [pageIndex]="page.pageId - 1"
                    [pageSizeOptions]="[5, 10, 25, 100]" data-cy="user-paginator">
                  </mat-paginator>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Tenant" *ngIf="userService.isAdmin">
    <div class="setting">
      <div class="title">Logo:</div>
      <div class="setting-subtitle">
        <ul type="circle">
          <li>The logo dimensions must be 162px x 54px.</li>
          <li>The background should be white or transparent.</li>
          <li>The format can only be either jpg or png.</li>
        </ul>
      </div>
      <app-tenant-setting></app-tenant-setting>
    </div>
  </mat-tab>


  <mat-tab label="Notifications">
    <div class="notifications" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="50px">
        <div class="panel">
          <div class="title">Email Notifications Settings</div>
          <div class="email-list">
            <div *ngFor="let userEmail of userEmailNotifications" class="item">
              <div class="email-config-item" (click)="updateUserEmailNotifications(userEmail)">
                <i class="email-config-icon rb rb-icon-toggle-{{userEmail.enabled?'on':'off'}}"
                  [class.highlight]="userEmail.enabled"></i>
                {{userEmail.name}} {{userEmail.type === 2 ? '*' : ''}}
              </div>
            </div>
          </div>
          <div class="sub-title">*Triggered for advertisers you are following only</div>
        </div>

        <div class="panel">
          <div class="title">Comments Notifications Settings</div>
          <div class="email-list notifications-list">
            <div *ngFor="let notification of commentsNotifications" class="item">
              <div class="email-config-item" (click)="updateCommentsNotifications(notification)">
                <i class="email-config-icon rb rb-icon-toggle-{{notification.disabled?'off':'on'}}"
                  [class.highlight]="!notification.disabled"></i>
                  {{notification.category?.description}}
                <!-- {{notification.category.name}} {{userEmail.type === 2 ? '*' : ''}} -->
              </div>
            </div>
          </div>
        </div>

        <div class="save-btn">
          <button mat-raised-button class="rubii-btn" color="primary" (click)="saveEmailAndNotificationPreferences()"><span
              style="margin: 0 1rem">Save</span></button>
        </div>
    </div>
  </mat-tab>

  <mat-tab label="AI" *ngIf="userService.isRubiiUser">
    <div class="ai-settings" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="50px">
      <mat-tab-group class="ai-tab-group flex-1" mat-stretch-tabs [selectedIndex]="selectedAiTabIndex" (selectedIndexChange)="updateAiTabIndex($event)">
        <mat-tab label="AI ChatBot" 
                 labelClass="ai-chatbot-tab-label"
                 bodyClass="ai-chatbot-tab-body">
          <div class="panel">
            <app-ai-bot *ngIf="selectedAiTabIndex === aiTabs.indexOf('ai-chatbot')"></app-ai-bot>
          </div>
        </mat-tab>
        
        <mat-tab label="AI Prompt Library" 
                 labelClass="ai-prompt-tab-label"
                 bodyClass="ai-prompt-tab-body">
          <div class="panel">
            <app-ai-prompt *ngIf="selectedAiTabIndex === aiTabs.indexOf('ai-prompt')"></app-ai-prompt>
          </div>
        </mat-tab>
        
        <mat-tab label="AI Agents" 
                 labelClass="ai-agents-tab-label"
                 bodyClass="ai-agents-tab-body">
          <div class="panel">
            <app-ai-agent *ngIf="selectedAiTabIndex === aiTabs.indexOf('ai-agents')"></app-ai-agent>
          </div>
        </mat-tab>
        
        <mat-tab label="AI Tools" 
                 labelClass="ai-tools-tab-label"
                 bodyClass="ai-tools-tab-body">
          <div class="panel">
            <app-ai-tool *ngIf="selectedAiTabIndex === aiTabs.indexOf('ai-tools')"></app-ai-tool>
          </div>
        </mat-tab>
        
        <mat-tab label="AI Tool Executions" 
                 labelClass="ai-tool-executions-tab-label"
                 bodyClass="ai-tool-executions-tab-body">
          <div class="panel">
            <app-ai-tool-executions *ngIf="selectedAiTabIndex === aiTabs.indexOf('ai-tool-executions')"></app-ai-tool-executions>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-tab>

</mat-tab-group>